import PropTypes from 'prop-types';
import React from 'react';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import moment from 'moment';

function formatDateRange(start, end) {
  const date1 = moment(start);
  const date2 = moment(end);
  let days = date1.format('Do');
  if (!date1.isSame(date2)) {
    days = `${days}-${date2.format('Do')}`;
  }
  return days;
}

function formatDateMonth(start) {
  return moment(start).format('MMM');
}

class HotelSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
    };
    this.setCurrentRoute = this.setCurrentRoute.bind(this);
  }
  setCurrentRoute(e) {
    e.preventDefault();
    this.props.selectRoute(e.target.value);
  }

  render() {
    const options = [];
    const stops = this.props.routes;
    // {} ? this.props.routes.length : this.props.width;
    for (let i = 0; i < stops.length; i++) {
      const label = `${stops[i].place.city}, ${stops[i].place.state}`;
      options.push(
        <option key={stops[i].id} value={stops[i].id}>
          {label}
        </option>
      );
    }
    return (
      <div className="hotel-dropdown">
        <FormGroup controlId="hotelSelector">
          <FormControl
            componentClass="select"
            placeholder="Select a city"
            value={this.props.current}
            onChange={this.setCurrentRoute}
          >
            {options}
          </FormControl>
        </FormGroup>
      </div>
    );
  }
}

HotelSelector.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  current: PropTypes.number.isRequired,
  selectRoute: PropTypes.func.isRequired,
};
export default HotelSelector;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSelector.js